import { render, staticRenderFns } from "./FormSelectSize.vue?vue&type=template&id=54b2bdf6&"
import script from "./FormSelectSize.vue?vue&type=script&lang=js&"
export * from "./FormSelectSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports